import { type RefObject } from "react";

const detectOutsideClick = (e: MouseEvent, ref: RefObject<HTMLDivElement>, callBack: () => void) => {
  if (ref.current && !ref.current.contains(e.target as Node)) {
    callBack();
  }
}

export default detectOutsideClick;
